import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import ObjectObservable from "../utils/ObjectObservable" ;
import CallData from "../classes/CallData" ;
import MaterialIcons from "../icons/MaterialIcons" ;
import User from "../models/User" ;
import PageNavigator from "../classes/PageNavigator" ;
import UserRole from "../classes/UserRole" ;
import IconButton from "./IconButton" ;
import SortedHeader from "./SortedHeader" ;
import LeadUtils from "../classes/LeadUtils" ;
import PaginationView from "./PaginationView" ;
import Query from "../classes/Query" ;
import SearchComponent from "./SearchComponent" ;
import Button from "./Button" ;
import ListWrapper from "../utils/ListWrapper" ;
import LeadsListRequest from "../models/LeadsListRequest" ;
import TwilioClient from "../classes/TwilioClient" ;
import Lead from "../models/Lead" ;
import LeadsList from "../classes/LeadsList" ;
import TextView from "./TextView" ;
import DFile from "../classes/DFile" ;
import CollectionUtils from "../utils/CollectionUtils" ;
import SuccessMessage from "../classes/SuccessMessage" ;
import LeadStatus from "../classes/LeadStatus" ;
import EventBus from "../utils/EventBus" ;
import LeadsListCountRequest from "../models/LeadsListCountRequest" ;
import DashboardCardWidget from "./DashboardCardWidget" ;
import Browser from "../classes/Browser" ;
import ScrollView2 from "./ScrollView2" ;
import LeadsListCount from "../classes/LeadsListCount" ;
import LabelDropdown from "./LabelDropdown" ;
import RPCServices from "../rpc/RPCServices" ;
import IconView from "./IconView" ;
import { UsageConstants } from "../rocket/D3ETemplate" ;
import { BuildContext } from "../classes/BuildContext" ;

type _ExportButtonOnPressed = ( d3eState : DashboardViewRefs ) => void ;

type _SearchComponentOnChanged = ( text : string,d3eState : DashboardViewRefs ) => void ;


  export  interface  DashboardViewProps extends  BaseUIProps {   key?: string ;
   client: TwilioClient ;
   data: CallData ;
   user: User ;
 }
/// To store state data for DashboardView 
   class  DashboardViewRefs {   column2ScrollController: ui.ScrollController = new ui.ScrollController() ;
  public exportButton: ExportButtonState = new ExportButtonState() ;
 }

   interface  ExportButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: DashboardViewRefs ;
   _onExportButtonHandler?: _ExportButtonOnPressed ;
 }

   class  ExportButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public _hover: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
  public get hover (  ) : boolean {
 return this._hover ; 
 }
  public setHover ( val : boolean ) {
 let isValChanged :boolean=this._hover !== val;

if ( !isValChanged ) {
 return ; 
 }

this._hover=val;

this.fire('hover',this);
 }
 }

   class  _ExportButtonWithState extends  ObservableComponent<ExportButtonWithStateProps> {   exportButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : ExportButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get exportButton (  ) : ExportButtonState {
 return this.props.d3eState.exportButton ; 
 }
  public get d3eState (  ) : DashboardViewRefs {
 return this.props.d3eState ; 
 }
  public get _onExportButtonHandler (  ) : _ExportButtonOnPressed {
 return this.props._onExportButtonHandler ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('exportButton',null,this.exportButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'exportButton', 'exportButton.Button', 'exportButton.hover' ],this.rebuild);
 }
  public exportButtonOnEnter ( event ) : void {
 return this.exportButton.setHover(true) ; 
 }
  public exportButtonOnExit ( event ) : void {
 return this.exportButton.setHover(false) ; 
 }
  public dispose (  ) : void {
 this.exportButton.setHover(false);

super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Container({ margin:ui.EdgeInsets.fromLTRB(0.0,0.0,10.0,0.0,new Map()), child:Button({ padding:cStyle.tButtonLightPaddingOn, decoration:cStyle.tButtonLightDecorationOn, disable:this.exportButton.disable, onPressed:(  ) => {
 this._onExportButtonHandler(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:ui.Row({ children:[ IconView({ size:18, icon:MaterialIcons.file_download, className:'x8b243', key:'0' }), TextView({ data:'Export', className:'x744', key:'1' }) ] }), onEnter:( event ) => {
 this.exportButtonOnEnter(event);
 }
, onExit:( event ) => {
 this.exportButtonOnExit(event);
 }
 }), className:'Light x40d' }) ; 
 }
 }
function ExportButtonWithState ( props : ExportButtonWithStateProps ) {
 return React.createElement(_ExportButtonWithState,props) ; 
 }


   class  _DashboardViewState extends  ObservableComponent<DashboardViewProps> {   static defaultProps = { client:null, data:null, user:null } ;
   d3eState: DashboardViewRefs = new DashboardViewRefs() ;
   request: LeadsListRequest = null ;
   leadsList: LeadsList = null ;
   leads: Array<Lead> = ListWrapper.widget(this,'leads') ;
   countRequest: LeadsListCountRequest = null ;
   leadsListCountQuery: LeadsListCount = null ;
   allLeads: Array<Lead> = ListWrapper.widget(this,'allLeads') ;
   filterByStatus: string = 'All' ;
   filterByRange: string = 'Today' ;
   searchLead: string = '' ;
   filteredLeads: Array<Lead> = ListWrapper.widget(this,'filteredLeads') ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : DashboardViewProps ) {
 super(props);

this.initState();
 }
  public get client (  ) : TwilioClient {
 return this.props.client ; 
 }
  public get data (  ) : CallData {
 return this.props.data ; 
 }
  public get user (  ) : User {
 return this.props.user ; 
 }
  public initState (  ) {
 super.initState();

this.initListeners();

this.enableBuild=true;

this.onInit();
 }
  public initListeners (  ) : void {
 this.on([ 'request', 'request.applyStatus', 'request.ascending', 'request.fromDate', 'request.offset', 'request.orderBy', 'request.pageSize', 'request.status', 'request.toDate', 'request.user' ],this.computeLeadsList);

this.computeLeadsList();

this.on([ 'leadsList', 'leadsList.items' ],this.computeLeads);

this.computeLeads();

this.on([ 'countRequest', 'countRequest.fromDate', 'countRequest.toDate', 'countRequest.user' ],this.computeLeadsListCountQuery);

this.computeLeadsListCountQuery();

this.on([ 'leadsListCountQuery', 'leadsListCountQuery.items' ],this.computeAllLeads);

this.computeAllLeads();

this.updateSyncProperty('data',this.props.data);

this.updateSyncProperty('user',this.props.user);

this.on([ 'leads', 'leads.email', 'leads.name', 'leads.phone', 'searchLead' ],this.computeFilteredLeads);

this.computeFilteredLeads();

this.on([ 'allLeads', 'allLeads.status', 'filterByRange', 'filterByStatus', 'filteredLeads', 'filteredLeads.createdDate', 'filteredLeads.email', 'filteredLeads.handlingUser', 'filteredLeads.handlingUser.firstName', 'filteredLeads.handlingUser.lastName', 'filteredLeads.name', 'filteredLeads.phone', 'filteredLeads.status', 'leadsList', 'leadsList.count', 'request', 'request.ascending', 'request.offset', 'request.orderBy', 'request.pageSize', 'searchLead' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : DashboardViewProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.client !== this.props.client ) {
 this.fire('client',this);
 }

if ( prevProps.data !== this.props.data ) {
 this.updateObservable('data',prevProps.data,this.props.data);

this.fire('data',this);
 }

if ( prevProps.user !== this.props.user ) {
 this.updateObservable('user',prevProps.user,this.props.user);

this.fire('user',this);
 }
 }
  public setRequest ( val : LeadsListRequest ) : void {
 let isValChanged :boolean=this.request !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('request',this.request,val);

this.request=val;

this.fire('request',this);
 }
  public setLeadsList ( val : LeadsList ) : void {
 let isValChanged :boolean=this.leadsList !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('leadsList',this.leadsList,val);

this.leadsList=val;

this.fire('leadsList',this);
 }
  public computeLeadsList  =  async  (  ) : Promise<void>  =>  {
 try {
 this.setLeadsList(( await Query.get().getLeadsList(UsageConstants.QUERY_GETLEADSLIST_DASHBOARDVIEW_PROPERTIES_LEADSLIST_COMPUTATION,this.request)));
 }
 catch ( exception ) {
 console.log(' exception in computeLeadsList : ' + exception.toString());

this.setLeadsList(null);
 }
 }
  public setLeads ( val : Array<Lead> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.leads,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('leads',this.leads,val);

this.leads.clear();

this.leads.addAll(val);

this.fire('leads',this);
 }
  public addToLeads ( val : Lead,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.leads.contains(val) ) this.leads.add(val);
 }
 else {
 this.leads.remove(this.leads.elementAt(index));

this.leads.add(val);
 }

this.fire('leads',this,val,true);

this.updateObservable('leads',null,val);
 }
  public removeFromLeads ( val : Lead ) : void {
 this.leads.remove(val);

this.fire('leads',this,val,false);

this.removeObservable('leads',val);
 }
  public computeLeads  =  (  ) : void  =>  {
 try {
 this.setLeads(Array.from(this.leadsList.items.isNotEmpty ? this.leadsList.items : [  ]));
 }
 catch ( exception ) {
 console.log(' exception in computeLeads : ' + exception.toString());

this.setLeads([  ]);
 }
 }
  public setCountRequest ( val : LeadsListCountRequest ) : void {
 let isValChanged :boolean=this.countRequest !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('countRequest',this.countRequest,val);

this.countRequest=val;

this.fire('countRequest',this);
 }
  public setLeadsListCountQuery ( val : LeadsListCount ) : void {
 let isValChanged :boolean=this.leadsListCountQuery !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('leadsListCountQuery',this.leadsListCountQuery,val);

this.leadsListCountQuery=val;

this.fire('leadsListCountQuery',this);
 }
  public computeLeadsListCountQuery  =  async  (  ) : Promise<void>  =>  {
 try {
 this.setLeadsListCountQuery(( await Query.get().getLeadsListCount(UsageConstants.QUERY_GETLEADSLISTCOUNT_DASHBOARDVIEW_PROPERTIES_LEADSLISTCOUNTQUERY_COMPUTATION,this.countRequest)));
 }
 catch ( exception ) {
 console.log(' exception in computeLeadsListCountQuery : ' + exception.toString());

this.setLeadsListCountQuery(null);
 }
 }
  public setAllLeads ( val : Array<Lead> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.allLeads,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('allLeads',this.allLeads,val);

this.allLeads.clear();

this.allLeads.addAll(val);

this.fire('allLeads',this);
 }
  public addToAllLeads ( val : Lead,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.allLeads.contains(val) ) this.allLeads.add(val);
 }
 else {
 this.allLeads.remove(this.allLeads.elementAt(index));

this.allLeads.add(val);
 }

this.fire('allLeads',this,val,true);

this.updateObservable('allLeads',null,val);
 }
  public removeFromAllLeads ( val : Lead ) : void {
 this.allLeads.remove(val);

this.fire('allLeads',this,val,false);

this.removeObservable('allLeads',val);
 }
  public computeAllLeads  =  (  ) : void  =>  {
 try {
 this.setAllLeads(Array.from(this.leadsListCountQuery.items.isNotEmpty ? this.leadsListCountQuery.items : [  ]));
 }
 catch ( exception ) {
 console.log(' exception in computeAllLeads : ' + exception.toString());

this.setAllLeads([  ]);
 }
 }
  public setFilterByStatus ( val : string ) : void {
 let isValChanged :boolean=this.filterByStatus !== val;

if ( !isValChanged ) {
 return ; 
 }

this.filterByStatus=val;

this.fire('filterByStatus',this);
 }
  public setFilterByRange ( val : string ) : void {
 let isValChanged :boolean=this.filterByRange !== val;

if ( !isValChanged ) {
 return ; 
 }

this.filterByRange=val;

this.fire('filterByRange',this);
 }
  public setSearchLead ( val : string ) : void {
 let isValChanged :boolean=this.searchLead !== val;

if ( !isValChanged ) {
 return ; 
 }

this.searchLead=val;

this.fire('searchLead',this);
 }
  public setFilteredLeads ( val : Array<Lead> ) : void {
 let isValChanged :boolean=CollectionUtils.isNotEquals(this.filteredLeads,val);

if ( !isValChanged ) {
 return ; 
 }

this.updateObservableColl('filteredLeads',this.filteredLeads,val);

this.filteredLeads.clear();

this.filteredLeads.addAll(val);

this.fire('filteredLeads',this);
 }
  public addToFilteredLeads ( val : Lead,index : number = -1 ) : void {
 if ( index === -1 ) {
 if ( !this.filteredLeads.contains(val) ) this.filteredLeads.add(val);
 }
 else {
 this.filteredLeads.remove(this.filteredLeads.elementAt(index));

this.filteredLeads.add(val);
 }

this.fire('filteredLeads',this,val,true);

this.updateObservable('filteredLeads',null,val);
 }
  public removeFromFilteredLeads ( val : Lead ) : void {
 this.filteredLeads.remove(val);

this.fire('filteredLeads',this,val,false);

this.removeObservable('filteredLeads',val);
 }
  public computeFilteredLeads  =  (  ) : void  =>  {
 try {
 this.setFilteredLeads(Array.from(this.leads.where(( l ) => (l.name !== null && l.name.contains(this.searchLead)) || (l.email !== null && l.email.contains(this.searchLead)) || (l.phone !== null && l.phone.contains(this.searchLead))).toList()));
 }
 catch ( exception ) {
 console.log(' exception in computeFilteredLeads : ' + exception.toString());

this.setFilteredLeads([  ]);
 }
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ScrollView2({child:ui.Column({ children:[ ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.spaceBetween, children:[ TextView({ data:'Overview', softWrap:true, style:new ui.TextStyle({fontSize:cStyle.tTextViewHeadlineFourFontSizeOn,fontWeight:cStyle.tTextViewHeadlineFourFontWeightOn}), className:'HeadlineFour xd9a', key:'0' }), ui.Row({ children:[ ui.Container({ margin:ui.EdgeInsets.fromLTRB(0.0,0.0,10.0,0.0,new Map()), child:LabelDropdown<string>({ value:this.filterByStatus, items:LeadUtils.leadStatuses, onChanged:( value ) => {
 this.onStatusFilterDropdownOnChangedHandler(value,this.d3eState);
 }
, builder:( context,item ) => {
 return TextView({ data:item }) ; 
 }
 }), key:'0', className:'x17d' }), LabelDropdown<string>({ value:this.filterByRange, items:LeadUtils.filterRanges, onChanged:( value ) => {
 this.onDateFilterDropdownOnChangedHandler(value,this.d3eState);
 }
, builder:( context,item ) => {
 return TextView({ data:item }) ; 
 }
, key:'1' }) ], key:'1' }) ], className:'x83 hc h', key:'0' }), ui.Row({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ui.Row({ children:[ ([ LeadStatus.New, LeadStatus.AttemptedContact, LeadStatus.Contacted, LeadStatus.FollowUp, LeadStatus.DemoRequested ]).expand(( topStatus ) => [ ui.Container({ expand:true, margin:ui.EdgeInsets.fromLTRB(0.0,0.0,10.0,0.0,new Map()), child:DashboardCardWidget({ title:topStatus, bgcolor:topStatus === LeadStatus.New ? cStyle.c4 : topStatus === LeadStatus.AttemptedContact ? cStyle.c9 : topStatus === LeadStatus.Contacted ? cStyle.c6 : topStatus === LeadStatus.FollowUp ? cStyle.c5 : cStyle.c4, statusCount:this.allLeads.where(( c ) => c.status.name === topStatus.name).length, onClick:( leadStatus ) => {
 this.onTopCardClickHandler(leadStatus,topStatus,this.d3eState);
 }
 }), key:topStatus?.toString(), className:'xafc hc h' }) ]) ], className:'x7ec5 hc h', key:'0' }), ui.Row({ children:[ ([ LeadStatus.Suspect, LeadStatus.Prospect, LeadStatus.ClosedWon, LeadStatus.Closed ]).expand(( bottomStatus ) => [ ui.Container({ expand:true, margin:ui.EdgeInsets.fromLTRB(0.0,0.0,10.0,0.0,new Map()), child:DashboardCardWidget({ title:bottomStatus, bgcolor:bottomStatus === LeadStatus.Suspect ? cStyle.c6 : bottomStatus === LeadStatus.Prospect ? cStyle.c5 : bottomStatus === LeadStatus.ClosedWon ? cStyle.c7 : bottomStatus === LeadStatus.Closed ? cStyle.c7 : cStyle.c5, statusCount:this.allLeads.where(( c ) => c.status.name === bottomStatus.name).length, onClick:( leadStatus ) => {
 this.onBottomCardClickHandler(leadStatus,bottomStatus,this.d3eState);
 }
 }), key:bottomStatus?.toString(), className:'x8a19 hc h' }) ]) ], className:'x737 hc h', key:'1' }) ], className:'x5623 hc h', key:'0' }) ], className:'xef2 hc h', key:'1' }), ui.Column({ crossAxisAlignment:ui.CrossAxisAlignment.start, children:[ ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.spaceBetween, children:[ TextView({ data:'Recent Leads', style:new ui.TextStyle({fontSize:cStyle.tTextViewHeadlineFourFontSizeOn,fontWeight:cStyle.tTextViewHeadlineFourFontWeightOn}), className:'HeadlineFour x2dfd', key:'0' }), ui.Container({ className:'x674 hc h', key:'1' }), ExportButtonWithState({ d3eState:this.d3eState, _onExportButtonHandler:this.onExportButtonHandler, key:'2' }), ui.Container({ width:300, child:SearchComponent({ placeholder:'Search', value:this.searchLead, onChanged:( text ) => {
 this.searchComponentonChanged(text,this.d3eState);
 }
 }), key:'3', className:'x5a0 hc' }) ], className:'x8b24 hc h', key:'0' }), ui.Table({ defaultColumnWidth:new ui.FlexColumnWidth(1), columnWidths:{0:new ui.FlexColumnWidth(1),1:new ui.FlexColumnWidth(1),2:new ui.FlexColumnWidth(1),3:new ui.FlexColumnWidth(1),4:new ui.FlexColumnWidth(1),5:new ui.FlexColumnWidth(1),6:new ui.FixedColumnWidth(70),}, children:[ ui.TableRow({ children:[ ui.TableCell({ child:SortedHeader({ name:'Created Date', assending:this.request.ascending, sorted:this.request.orderBy === 'createdDate', onChanged:( value ) => {
 this.onCreatedDateSortedHeaderOnChangedHandler(value,this.d3eState);
 }
, className:'xbbc hc h' }), className:'TableCellHeader table-column x0d9 hc h', key:'0' }), ui.TableCell({ child:SortedHeader({ name:'Name', assending:this.request.ascending, sorted:this.request.orderBy === 'name', onChanged:( value ) => {
 this.onNameSortedHeaderOnChangedHandler(value,this.d3eState);
 }
, className:'xbb1 hc h' }), className:'TableCellHeader table-column x8f9 hc h', key:'1' }), ui.TableCell({ child:SortedHeader({ name:'Phone', assending:this.request.ascending, sorted:this.request.orderBy === 'phone', onChanged:( value ) => {
 this.onPhoneSortedHeaderOnChangedHandler(value,this.d3eState);
 }
, className:'x546 hc h' }), className:'TableCellHeader table-column xeda hc h', key:'2' }), ui.TableCell({ child:SortedHeader({ name:'Email', assending:this.request.ascending, sorted:this.request.orderBy === 'email', onChanged:( value ) => {
 this.onEmailSortedHeaderOnChangedHandler(value,this.d3eState);
 }
, className:'x5fc7 hc h' }), className:'TableCellHeader table-column xfb3 hc h', key:'3' }), ui.TableCell({ child:TextView({ data:'Assigned To', className:'hc' }), className:'TableCellHeader table-column x3ec hc', key:'4' }), ui.TableCell({ child:SortedHeader({ name:'Status', assending:this.request.ascending, sorted:this.request.orderBy === 'status', onChanged:( value ) => {
 this.onStatusSortedHeaderOnChangedHandler(value,this.d3eState);
 }
, className:'x67c hc h' }), className:'TableCellHeader table-column x488 hc h', key:'5' }), ui.TableCell({ child:TextView({ data:'', className:'hc' }), className:'TableCellHeader table-column xd7b hc', key:'6' }) ], className:'TableHeader table-row x3db hc h', key:'0' }), (this.filteredLeads).expand(( forItem ) => [ ui.TableRow({ children:[ ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:forItem.createdDate !== null ? LeadUtils.toGMTFromDateTime(forItem.createdDate,{ format:'dd EEE, MMM y HH:mm' }) : '', className:'hc' }), className:'table-column hc', key:'0' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:forItem.name, className:'hc' }), className:'table-column hc', key:'1' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:forItem.phone, className:'hc' }), className:'table-column hc', key:'2' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:forItem.email, className:'hc' }), className:'table-column hc', key:'3' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:TextView({ data:(forItem.handlingUser?.firstName ?? '') + ' ' + (forItem.handlingUser?.lastName ?? ''), className:'hc' }), className:'table-column hc', key:'4' }), ui.TableCell({ verticalAlignment:ui.TableCellVerticalAlignment.middle, child:ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.start, children:[ ui.Container({ alignment:ui.Alignment.center, states:ui.joinStates({ 'data-c0':forItem.status.name === 'New', 'data-c1':forItem.status.name === 'Inprogress', 'data-c2':forItem.status.name === 'Closed', 'data-c3':forItem.status.name === 'Contacted', 'data-c4':forItem.status.name === 'Attempted Contact', 'data-c5':forItem.status.name === 'Follow Up', 'data-c6':forItem.status.name === 'Suspect', 'data-c7':forItem.status.name === 'Prospect', 'data-c8':forItem.status.name === 'Closed Won' },{}), padding:forItem.status.name === 'New' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : forItem.status.name === 'Inprogress' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : forItem.status.name === 'Closed' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : forItem.status.name === 'Contacted' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : forItem.status.name === 'Attempted Contact' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : forItem.status.name === 'Follow Up' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : forItem.status.name === 'Suspect' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : forItem.status.name === 'Prospect' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : forItem.status.name === 'Closed Won' ? ui.EdgeInsets.symmetric({horizontal:20.0,vertical:5.0,transitions:new Map()}) : null, decoration:forItem.status.name === 'New' ? new ui.BoxDecoration({color:cStyle.c4,borderRadius:ui.BorderRadius.circular(3.0)}) : forItem.status.name === 'Inprogress' ? new ui.BoxDecoration({color:cStyle.c5,borderRadius:ui.BorderRadius.circular(3.0)}) : forItem.status.name === 'Closed' ? new ui.BoxDecoration({color:cStyle.c7,borderRadius:ui.BorderRadius.circular(3.0)}) : forItem.status.name === 'Contacted' ? new ui.BoxDecoration({color:cStyle.c6,borderRadius:ui.BorderRadius.circular(3.0)}) : forItem.status.name === 'Attempted Contact' ? new ui.BoxDecoration({color:cStyle.c6,borderRadius:ui.BorderRadius.circular(3.0)}) : forItem.status.name === 'Follow Up' ? new ui.BoxDecoration({color:cStyle.c6,borderRadius:ui.BorderRadius.circular(3.0)}) : forItem.status.name === 'Suspect' ? new ui.BoxDecoration({color:cStyle.c4,borderRadius:ui.BorderRadius.circular(3.0)}) : forItem.status.name === 'Prospect' ? new ui.BoxDecoration({color:cStyle.c9,borderRadius:ui.BorderRadius.circular(3.0)}) : forItem.status.name === 'Closed Won' ? new ui.BoxDecoration({color:cStyle.c7,borderRadius:ui.BorderRadius.circular(3.0)}) : new ui.BoxDecoration({  }), child:TextView({ data:forItem.status.name, style:new ui.TextStyle({color:cStyle.c14}), className:'xebd hc' }), className:'xafcb hc', key:'0' }), ui.Container({ key:'1' }) ], className:'x1b hc h' }), className:'table-column x5e81 hc h', key:'5' }), ui.TableCell({ child:IconButton({ icon:MaterialIcons.edit, tooltip:'Edit', onPressed:(  ) => {
 this.onLeadEditHandler(forItem,this.d3eState);
 }
, className:'hc' }), className:'table-column hc', key:'6' }) ], onTap:( e ) => {
 e.stopPropagation();

this.onLeadSelectHandler(forItem,this.d3eState);
 }
, className:'TableRow1 table-row x21f hc h', key:forItem?.ident }) ]) ], className:'Table1 xaaa hc h', key:'1' }), ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.end, children:[ PaginationView({ pageSize:this.request.pageSize, total:this.leadsList?.count ?? 0, offset:this.request.offset, onChange:( pageSize,offset ) => {
 this.onChangePaginationViewHandler(pageSize,offset,this.d3eState);
 }
, key:'0' }) ], className:'x4fe hc h', key:'2' }) ], className:'BaseViewStyle x0ab hc h', key:'2' }) ], className:ui.join('DashboardView xed0 hc vc h v ' , this.props.className ?? ''), ...copyBaseUIProps(this.props,) }),scrollDirection:ui.Axis.vertical,className:'DashboardView xed0 hc vc h v',controller:this.d3eState.column2ScrollController}) ; 
 }
  public onInit  =  (  ) : void  =>  {
 this.setFilterByRange('Current Week');

this.setRequest(new LeadsListRequest({ user:((this.user.role === UserRole.Admin) ? null : this.user), pageSize:50, offset:0, orderBy:'', ascending:false, fromDate:LeadUtils.getFromDateFilter(this.filterByRange), toDate:LeadUtils.getToDateFilter(this.filterByRange), applyStatus:false }));

this.setCountRequest(new LeadsListCountRequest({ user:((this.user.role === UserRole.Admin) ? null : this.user), fromDate:LeadUtils.getFromDateFilter(this.filterByRange), toDate:LeadUtils.getToDateFilter(this.filterByRange) }));
 }
  public onExportButtonHandler  =  async  ( d3eState : DashboardViewRefs ) : Promise<void>  =>  {
 let exportLeads :Array<Lead>=this.filteredLeads !== null ? this.filteredLeads : [  ];

let file :DFile=( await RPCServices.getExportFileUtils().createCSVForLeads(exportLeads));

if ( file !== null ) {
 Browser.download(file);

EventBus.get().fire(new SuccessMessage({ message:'Downloaded successfully.' }));
 }
 }
  public onChangePaginationViewHandler  =  ( pageSize : number,offset : number,d3eState : DashboardViewRefs ) : void  =>  {
 this.request.setPageSize(pageSize);

this.request.setOffset(offset);

this.setRequest(this.request.deepClone());
 }
  public onLeadSelectHandler  =  ( forItem : Lead,d3eState : DashboardViewRefs ) : void  =>  {
 this.navigator.pushLeadOverviewPage({ lead:forItem, user:this.user, client:this.client, data:this.data, replace:false, target:'main' });
 }
  public onCreatedDateSortedHeaderOnChangedHandler  =  ( value : boolean,d3eState : DashboardViewRefs ) : void  =>  {
 this.request.setOrderBy('createdDate');

this.request.setAscending(value);

this.setRequest(this.request.deepClone());
 }
  public onNameSortedHeaderOnChangedHandler  =  ( value : boolean,d3eState : DashboardViewRefs ) : void  =>  {
 this.request.setOrderBy('name');

this.request.setAscending(value);

this.setRequest(this.request.deepClone());
 }
  public onPhoneSortedHeaderOnChangedHandler  =  ( value : boolean,d3eState : DashboardViewRefs ) : void  =>  {
 this.request.setOrderBy('phone');

this.request.setAscending(value);

this.setRequest(this.request.deepClone());
 }
  public onEmailSortedHeaderOnChangedHandler  =  ( value : boolean,d3eState : DashboardViewRefs ) : void  =>  {
 this.request.setOrderBy('email');

this.request.setAscending(value);

this.setRequest(this.request.deepClone());
 }
  public onStatusSortedHeaderOnChangedHandler  =  ( value : boolean,d3eState : DashboardViewRefs ) : void  =>  {
 this.request.setOrderBy('status');

this.request.setAscending(value);

this.setRequest(this.request.deepClone());
 }
  public onStatusFilterDropdownOnChangedHandler  =  ( value : string,d3eState : DashboardViewRefs ) : void  =>  {
 this.setFilterByStatus(value);

if ( value !== 'All' ) {
 this.request.setStatus(LeadStatus.values.firstWhere(( e ) => e.name === value,{ orElse:(  ) => null }));
 }

this.request.setApplyStatus(value === 'All' ? false : true);

this.setRequest(this.request.deepClone());
 }
  public onDateFilterDropdownOnChangedHandler  =  ( value : string,d3eState : DashboardViewRefs ) : void  =>  {
 this.setFilterByRange(value);

this.request.setFromDate(LeadUtils.getFromDateFilter(this.filterByRange));

this.request.setToDate(LeadUtils.getToDateFilter(this.filterByRange));

this.setRequest(this.request.deepClone());

this.countRequest.setFromDate(LeadUtils.getFromDateFilter(this.filterByRange));

this.countRequest.setToDate(LeadUtils.getToDateFilter(this.filterByRange));

this.setCountRequest(this.countRequest.deepClone());
 }
  public onLeadEditHandler  =  ( forItem : Lead,d3eState : DashboardViewRefs ) : void  =>  {
 this.navigator.pushLeadInformationPage({ user:this.user, lead:forItem, replace:false, client:this.client, target:'main', data:this.data, isNewObj:false });
 }
  public onTopCardClickHandler  =  ( leadStatus : LeadStatus,topStatus : LeadStatus,d3eState : DashboardViewRefs ) : void  =>  {
 this.request.setApplyStatus(true);

this.request.setStatus(leadStatus);

this.setRequest(this.request.deepClone());
 }
  public onBottomCardClickHandler  =  ( leadStatus : LeadStatus,bottomStatus : LeadStatus,d3eState : DashboardViewRefs ) : void  =>  {
 this.request.setApplyStatus(true);

this.request.setStatus(leadStatus);

this.setRequest(this.request.deepClone());
 }
  public searchComponentonChanged  =  ( val : string,d3eState : DashboardViewRefs ) : void  =>  {
 this.setSearchLead(val);
 }
  public get navigator (  ) : PageNavigator {
 return PageNavigator.of(this.context) ; 
 }
  public get exportButton (  ) {
 return this.d3eState.exportButton ; 
 }
 }
export default function DashboardView ( props : DashboardViewProps ) {
 return React.createElement(_DashboardViewState,{ ..._DashboardViewState.defaultProps, ...props }) ; 
 }
